import React, {useState} from 'react';
import axios from 'axios';

import logo from './logo.svg';

import './App.css';
import './components/utils/globalCss/colorsGlobalTheme.css'
import Navbar from './components/navbar/navbar';
import ShopingCard from './components/shopingCard/shopingCard';
import HomePage from './components/homePage/homePage';
import './components/utils/timeago/timeagoEs';
import URL from './components/config/config-server-api'

import { 
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory
} from 'react-router-dom';

import SignUpForm from './components/login/signup/signUp';
import MenuOptionsMitienda from './components/tienda/menuOptions/menuOptions'
import ListaDeProductos from './components/tienda/listaProductos/listaProducto';
import HomeConent from './components/homePage/homeContent';
 function App()  {

  let history = useHistory();
  
  const [userData, setUserData] = useState({
    _id:"",
    name:'',
    role:'',
    lastName: '',
    email: '',
    phoneNumber:0,
    password:'',
    fotoAvatar:'',
    token: ''
  })

  const [initidalData, setInitialData]=useState({
    idTienda: process.env.REACT_APP_ID_TIENDA,
  });

  const [dataTIENDA,setDataTIENDA] = useState({})
  
  const handleDatTienda=(TIENDA)=>{

    // console.log(TIENDA)
    // console.log('TIENDA')
    if(TIENDA){
      setDataTIENDA(TIENDA)
    }
  }

  const updateUserData=(userD)=>{
    setUserData(userD)
  }

  
  React.useEffect(()=>{
    
    // hoots que cargas los datosiniciales de la tienda
    // peticionAlaApi();

    const dUser = JSON.parse(localStorage.getItem('dataUser'));
    if(dUser){
      setUserData(dUser);
    }
  },[])


  return (
    <div className="App" >
     
     {/* {JSON.stringify(userData)} */}

     {/* <div className="mt-20">{initidalData.idTienda}</div> */}

     <Router>
     <HomePage updateUserData={updateUserData} userData={userData} dataTIENDA={dataTIENDA}></HomePage>

       <Switch>
          <Route exact path="/">
            <HomeConent handleDatTienda={handleDatTienda} ></HomeConent>
          </Route>
          {
            userData?.role==="owner"?
            <>
              <Route  path="/mitienda/">
                <MenuOptionsMitienda userData={userData} ></MenuOptionsMitienda>
              </Route>
            </>
            : 
            <Route exact path="/mitienda">
              <HomeConent ></HomeConent>
            </Route>
            
          }
          
         
       </Switch>
     </Router>

     
    </div>
  );
}

export default App;
